export default __webpack_public_path__ + "static/media/placeholder_business04-fr-mobile.fb0c67c8.png";